module.exports = __webpack_public_path__ + "static/mansion_350-20d5a8eb738d71cba4202d77f80bc349.jpg";